import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { handleSubmit } from "../../../../auxiliar/auxFunctions";

const OverviewCard = ({
    item,
    id,
    navigate,
    getDetailPath,
    renderTitle,
    renderSubtitle,
    renderFooter,
    renderActions,
    className = "",
}) => {
    return (
        <div
            className={`bg-base-200 rounded-lg shadow-md shadow-primary/10 border border-base-300 p-3 sm:p-4 hover:shadow-lg hover:shadow-primary/25 hover:bg-base-200/80 transition-all duration-200 ${className}`}
        >
            {/* Header section with title, subtitle and button */}
            <div className="flex items-start justify-between gap-3 mb-3">
                <div className="flex-1 min-w-0">
                    <div className="font-semibold text-base-content text-base sm:text-lg leading-tight">
                        {renderTitle(item)}
                    </div>
                    {renderSubtitle && (
                        <div className="text-base-content/70 text-xs sm:text-sm mt-1 leading-relaxed">
                            {renderSubtitle(item)}
                        </div>
                    )}
                </div>

                {/* Button - compact and aligned to top-right */}
                <div className="flex-shrink-0">
                    {renderActions ? (
                        renderActions(item, id)
                    ) : (
                        <button
                            type="button"
                            className="btn btn-primary btn-xs sm:btn-sm text-xs sm:text-sm"
                            onClick={handleSubmit(navigate, getDetailPath(id))}
                        >
                            <FontAwesomeIcon
                                icon={faEye}
                                className="mr-1 sm:mr-2 text-xs sm:text-sm"
                            />
                            <span className="sm:hidden">Ver</span>
                            <span className="hidden sm:inline">Detalles</span>
                        </button>
                    )}
                </div>
            </div>

            {/* Footer section - if present */}
            {renderFooter && (
                <div className="pt-2 border-t border-base-300/30">{renderFooter(item)}</div>
            )}
        </div>
    );
};

const OverviewCardList = ({
    data,
    navigate,
    getDetailPath,
    renderTitle,
    renderSubtitle,
    renderFooter,
    renderActions,
    className = "",
}) => {
    return (
        <div className={`block lg:hidden space-y-3 px-1 sm:px-0 ${className}`}>
            {data.order.map((id) => {
                const item = data.content && data.content[id];
                return (
                    <OverviewCard
                        key={id}
                        item={item}
                        id={id}
                        navigate={navigate}
                        getDetailPath={getDetailPath}
                        renderTitle={renderTitle}
                        renderSubtitle={renderSubtitle}
                        renderFooter={renderFooter}
                        renderActions={renderActions}
                    />
                );
            })}
        </div>
    );
};

export { OverviewCard, OverviewCardList };
export default OverviewCardList;
